import { initializeApp } from "firebase/app";
import { getFirestore, limit, orderBy } from "firebase/firestore";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  doc,
  query,
  where,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD3tgalF4YmUq67bZTdfqoFrkC254JM3rU",
  authDomain: "medicomp-53eac.firebaseapp.com",
  projectId: "medicomp-53eac",
  storageBucket: "medicomp-53eac.appspot.com",
  messagingSenderId: "767435323964",
  appId: "1:767435323964:web:1744be72ab16ef7c5b2139",
  measurementId: "G-0QBZ6G66BH",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);
const auth = getAuth(app);

const addDocToCollection = (collectionName, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const docRef = await addDoc(collection(db, collectionName), data);
      resolve(docRef.id);
    } catch (error) {
      reject(error);
    }
  });
};

const editBooking = (uid, bookingId, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const docRef = await updateDoc(doc(db, "bookings", bookingId), data);
      resolve(docRef.id);
    } catch (error) {
      reject(error);
    }
  });
};

const getPendingBookings = (uid) => {
  return new Promise(async (resolve, reject) => {
    try {
      const q = query(
        collection(db, "bookings"),
        where("uid", "==", uid),
        where("status", "==", "paymentPending"),
        orderBy("timestamp", "desc"),
        limit(1)
      );
      const querySnapshot = await getDocs(q);
      const data = [];
      querySnapshot.docs.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const changePaymentStatus = (uid, bookingId, data) => {
  console.log(uid, bookingId, data);
  return new Promise(async (resolve, reject) => {
    try {
      const docRef = await updateDoc(doc(db, "bookings", bookingId), data);
      resolve(docRef);
    } catch (error) {
      reject(error);
    }
  });
};

const handleResetPassword = (email) => {
  return new Promise(async (resolve, reject) => {
    sendPasswordResetEmail(auth, email)
      .then(() => {
        resolve();
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getBookings = (uid) => {
  return new Promise(async (resolve, reject) => {
    try {
      const querySnapshot = await getDocs(
        collection(db, "bookings").where("uid", "==", uid)
      );
      const data = querySnapshot.docs.map((doc) => doc.data());
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const createSupportTicket = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const docRef = await addDoc(collection(db, "tickets"), data);
      resolve(docRef.id);
    } catch (error) {
      reject(error);
    }
  });
};

const createUserDocument = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const docRef = await addDoc(collection(db, "users"), data);
      resolve(docRef.id);
    } catch (error) {
      reject(error);
    }
  });
};

const getUserDetails = (uid) => {
  return new Promise(async (resolve, reject) => {
    try {
      console.log(uid);
      const q = query(collection(db, "users"), where("uid", "==", uid));
      const querySnapshot = await getDocs(q);
      const data = [];
      querySnapshot.docs.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const updateUserDetails = (id, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const docRef = await updateDoc(doc(db, "users", id), data);
      resolve(docRef);
    } catch (error) {
      reject(error);
    }
  });
};

const getUserData = (uid) => {
  return new Promise(async (resolve, reject) => {
    try {
      const q = query(collection(db, "users"), where("uid", "==", uid));
      const querySnapshot = await getDocs(q);
      const data = [];
      querySnapshot.docs.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getSurgeries = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const querySnapshot = await getDocs(collection(db, "surgeries"));
      const data = querySnapshot.docs.map((doc) => doc.data());
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export {
  addDocToCollection,
  getSurgeries,
  getUserData,
  handleResetPassword,
  getUserDetails,
  editBooking,
  getPendingBookings,
  changePaymentStatus,
  createSupportTicket,
  createUserDocument,
  getBookings,
  updateUserDetails,
};
